export { getProfileDetails as getProfileDetails };
export { fetchKycRefData as fetchKycRefData };
export { fetchCoin as fetchCoin };
export { fetchRefData as fetchRefData };
import libs_api_api from '@/libs/api/api';

async function getProfileDetails(ctx) {
  ctx.commit("setUser");
}
async function fetchKycRefData({
  commit
}) {
  const response = await new libs_api_api().api({
    method: "GET",
    url: "kyc/refData/IN"
  }, {}, {});
  if (response.result.errors) {
    return;
  }
  commit("setKycRefData", response.refData);
}
async function fetchCoin({
  commit
}) {
  const response = await new libs_api_api().api({
    method: "GET",
    url: "p2p/public/coins"
  }, {}, {});
  if (response.result.errors) {
    return;
  }
  commit("setKycRefData", response.coins);
}
async function fetchRefData({
  commit
}) {
  const response = await new libs_api_api().api({
    method: "GET",
    url: "p2p/public/coins"
  }, {}, {});
  if (response.result.errors) {
    return;
  }
  commit("setRefData", response.refData);
}

export default { getProfileDetails, fetchKycRefData, fetchCoin, fetchRefData };
